import { render } from "./SummaryPlanV14.vue?vue&type=template&id=12c0a886&scoped=true"
import script from "./SummaryPlanV14.vue?vue&type=script&lang=ts"
export * from "./SummaryPlanV14.vue?vue&type=script&lang=ts"

import "./SummaryPlanV14.vue?vue&type=style&index=0&id=12c0a886&lang=scss&scoped=true"
import "./SummaryPlanV14.vue?vue&type=style&index=1&id=12c0a886&lang=scss"
script.render = render
script.__scopeId = "data-v-12c0a886"

export default script